module.exports = __webpack_public_path__ + "img/bg_function02_1_d.ed951a65.png";